import __request__ from "routing/request";
export function list(sort = "parsed_rule.title", page = 1, per_page = 15, query, filters, user_timezone = "UTC", direction = "asc", requestOptions) {
  return __request__("GET", "/plugins/org.graylog.plugins.securityapp/sigma/rules", null, { "page": page, "per_page": per_page, "query": query, "filters": filters, "user_timezone": user_timezone, "sort": sort, "direction": direction }, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function create(JSONBody, requestOptions) {
  return __request__("POST", "/plugins/org.graylog.plugins.securityapp/sigma/rules", JSONBody, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function bulkConfigurationUpdate(JSONBody, requestOptions) {
  return __request__("PUT", "/plugins/org.graylog.plugins.securityapp/sigma/rules/bulk/add_notifications", JSONBody, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function deleteBulk(JSONBody, requestOptions) {
  return __request__("PUT", "/plugins/org.graylog.plugins.securityapp/sigma/rules/bulk/delete", JSONBody, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function disableBulk(JSONBody, requestOptions) {
  return __request__("PUT", "/plugins/org.graylog.plugins.securityapp/sigma/rules/bulk/disable", JSONBody, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function enableBulk(JSONBody, requestOptions) {
  return __request__("PUT", "/plugins/org.graylog.plugins.securityapp/sigma/rules/bulk/enable", JSONBody, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function download(ruleIds, requestOptions) {
  return __request__("GET", "/plugins/org.graylog.plugins.securityapp/sigma/rules/download", null, { "ruleIds": ruleIds }, {
    "Accept": ["application/octet-stream"]
  }, requestOptions);
}
export function getFilterOptions(JSONBody, requestOptions) {
  return __request__("POST", "/plugins/org.graylog.plugins.securityapp/sigma/rules/filter_options", JSONBody, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function importRules(JSONBody, requestOptions) {
  return __request__("POST", "/plugins/org.graylog.plugins.securityapp/sigma/rules/import", JSONBody, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function listRulesThatCanMatchIngestedMessages(sort = "parsed_rule.title", page = 1, per_page = 15, query, filters, user_timezone = "UTC", direction = "asc", requestOptions) {
  return __request__("GET", "/plugins/org.graylog.plugins.securityapp/sigma/rules/that_can_match", null, { "page": page, "per_page": per_page, "query": query, "filters": filters, "user_timezone": user_timezone, "sort": sort, "direction": direction }, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function upload(files, requestOptions) {
  const formData = new FormData();
  files.forEach((f) => formData.append("files", f));
  return __request__("POST", "/plugins/org.graylog.plugins.securityapp/sigma/rules/upload", formData, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function validate(JSONBody, requestOptions) {
  return __request__("POST", "/plugins/org.graylog.plugins.securityapp/sigma/rules/validate", JSONBody, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function validateZip(file, requestOptions) {
  const formData = new FormData();
  formData.append("file", file);
  return __request__("POST", "/plugins/org.graylog.plugins.securityapp/sigma/rules/validate_zip", formData, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function get(id, requestOptions) {
  return __request__("GET", `/plugins/org.graylog.plugins.securityapp/sigma/rules/${id}`, null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function update(id, JSONBody, requestOptions) {
  return __request__("PUT", `/plugins/org.graylog.plugins.securityapp/sigma/rules/${id}`, JSONBody, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function remove(id, requestOptions) {
  return __request__("DELETE", `/plugins/org.graylog.plugins.securityapp/sigma/rules/${id}`, null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function disable(id, requestOptions) {
  return __request__("PUT", `/plugins/org.graylog.plugins.securityapp/sigma/rules/${id}/disable`, null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function enable(id, requestOptions) {
  return __request__("PUT", `/plugins/org.graylog.plugins.securityapp/sigma/rules/${id}/enable`, null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
